import React, { useEffect, useState } from "react";
import {
  Row,
  Label,
  Input,
  Form,
  FormGroup,
  FormFeedback,
  Button,
  Col,
} from "reactstrap";
import { useFormik } from "formik";
import * as yup from "yup";
//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";
import { Link } from "react-router-dom";
import { setAuthorization } from "../../../helpers/api_helper";
import {
  getPublicCountries,
  getPublicGenders,
} from "../../../helpers/dataBackend";
import { useTranslation } from "react-i18next";

interface BasicInformationProps {
  onSubmit: (values: any) => void;
  onBack: () => void;
  data?: any;
}

const BasicInformation = ({
  onSubmit,
  onBack,
  data,
}: BasicInformationProps) => {
  //meta title
  document.title = "Ditobanx";
  const { t } = useTranslation();

  const [gender, setGenders] = useState<any[]>([]);
  const [countries, setCountries] = useState<any[]>([]);

  const getData = async () => {
    const responsePublicToken = localStorage.getItem("publicToken");
    setAuthorization(responsePublicToken); // Guardar el token antes de continuar

    const response = await getPublicGenders();
    // console.log("response", JSON.parse(response.data));
    setGenders(JSON.parse(response.data));

    const responseCountries = await getPublicCountries();
    // console.log(responseCountries);
    setCountries(JSON.parse(responseCountries.data));
  };

  useEffect(() => {
    getData();
  }, []);

  const formik: any = useFormik({
    initialValues: {
      name: (data.basicInfo && data.basicInfo.name) || "",
      last_name: (data.basicInfo && data.basicInfo.last_name) || "",
      email: (data.basicInfo && data.basicInfo.email) || "",
      gender: (data.basicInfo && data.basicInfo.gender) || "",
      phoneCode: (data.basicInfo && data.basicInfo.phoneCode) || "",
      phone: (data.basicInfo && data.basicInfo.phone) || "",
      country: (data.basicInfo && data.basicInfo.country) || "",
    },
    validationSchema: yup.object().shape({
      name: yup.string().required("Please Enter Your Name"),
      last_name: yup.string().required("Please Enter Your Last Name"),
      email: yup.string().email().required("Please Enter Your Email"),
      gender: yup.string().required("Please Select Your Gender"),
      phoneCode: yup.string().required("Please Enter Your Phone Number"),
      phone: yup
        .string()
        .matches(/^\d+$/, "Phone must contain only numbers")
        .max(11, "Phone cannot be longer than 11 digits")
        .required("Please Enter Your Phone Number"),
      country: yup.string().required("Please Enter Your Country"),
    }),
    onSubmit: (values: any) => {
      // console.log("values", values);
      onSubmit(values);
    },
  });

  return (
    <React.Fragment>
      <Form onSubmit={formik.handleSubmit} autoComplete="off">
        <Row>
          <Col lg={6}>
            {/* NOMBRE */}
            <FormGroup className="mb-3">
              <Label htmlFor="name"> {t("Name")} </Label>
              <Input
                type="text"
                id="name"
                placeholder={t("Enter Name")}
                name="name"
                value={formik.values.name || ""}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                invalid={
                  formik.touched.name && formik.errors.name ? true : false
                }
              />
              {formik.touched.name && formik.errors.name ? (
                <FormFeedback type="invalid">{formik.errors.name}</FormFeedback>
              ) : null}
            </FormGroup>
          </Col>
          <Col lg={6}>
            {/* APELLIDO */}
            <FormGroup className="mb-3">
              <Label htmlFor="last_name"> {t("Last name")} </Label>
              <Input
                type="text"
                id="last_name"
                placeholder={t("Enter LastName")}
                name="last_name"
                value={formik.values.last_name || ""}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                invalid={
                  formik.touched.last_name && formik.errors.last_name
                    ? true
                    : false
                }
              />
              {formik.touched.last_name && formik.errors.last_name ? (
                <FormFeedback type="invalid">
                  {formik.errors.last_name}
                </FormFeedback>
              ) : null}
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col lg={6}>
            {/* EMAIL */}
            <FormGroup className="mb-3">
              <Label htmlFor="kyclastname-input">{t("Email")}</Label>
              <Input
                type="email"
                id="email-input"
                placeholder={t("Enter Email")}
                name="email"
                value={formik.values.email || ""}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                invalid={
                  formik.touched.email && formik.errors.email ? true : false
                }
              />
              {formik.touched.email && formik.errors.email ? (
                <FormFeedback type="invalid">
                  {formik.errors.email}
                </FormFeedback>
              ) : null}
            </FormGroup>
          </Col>
          <Col lg={6}>
            {/* GENERO */}
            <FormGroup className="mb-3">
              <Label htmlFor="gender"> {t("Gender")} </Label>
              <select
                className="form-control"
                name="gender"
                id="gender"
                value={formik.values.gender || ""}
                onChange={formik.handleChange}
              >
                <option value="" selected disabled>
                  Elige una opcion
                </option>
                {gender.map((item) => (
                  <option id={item.code} value={item.code}>
                    {item.name}
                  </option>
                ))}
              </select>
              {formik.errors.gender && formik.touched.gender ? (
                <span className="text-danger">{formik.errors.gender}</span>
              ) : null}
            </FormGroup>
          </Col>
        </Row>
        {/* PAIS RESIDENCIA */}
        <FormGroup className="mb-3">
          <Label htmlFor="country"> {t("Country of residence")} </Label>
          <select
            className="form-control"
            name="country"
            id="country"
            value={formik.values.country || ""}
            onChange={formik.handleChange}
          >
            <option value="" selected disabled>
              Elige una opcion
            </option>
            {countries.map((item) => (
              <option id={item.code_iso_31661} value={item.code_iso_31661}>
                {item.name}
              </option>
            ))}
          </select>
          {formik.errors.country && formik.touched.country ? (
            <span className="text-danger">{formik.errors.country}</span>
          ) : null}
        </FormGroup>
        {/* Phone number */}
        <FormGroup className="mb-3">
          <Label htmlFor="phone">{t("Phone Number")} </Label>
          <div className="d-flex gap-2">
            {/* Dropdown con códigos de países */}
            <Input
              type="select"
              style={{ width: "150px" }}
              name="phoneCode"
              value={formik.values.phoneCode || ""}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className="form-select w-[140px]"
            >
              <option value="" selected disabled>
                Elige
              </option>
              {countries.map((country) => (
                <option key={country.id} value={"+" + country.phone_area_code}>
                  {country.acronym} (+{country.phone_area_code})
                </option>
              ))}
            </Input>
            <Input
              className="form-control"
              name="phone"
              id="phone"
              type="number"
              value={formik.values.phone}
              // format="(###) ####-####"
              onChange={formik.handleChange}
              placeholder="Enter Phone number"
              onBlur={formik.handleBlur}
            />
          </div>
          {formik.touched.phone && formik.errors.phone ? (
            <span className="text-danger">{formik.errors.phone}</span>
          ) : null}
        </FormGroup>
        <div
          style={{
            marginTop: "20px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Link
            to="/select-type"
            type="button"
            className="btn btn-secondary me-2"
          >
            Regresar
          </Link>
          <Button type="submit" style={{ backgroundColor: "blue" }}>
            Siguiente
          </Button>
        </div>
      </Form>
    </React.Fragment>
  );
};

export default BasicInformation;
